import React             from 'react';
import { Redirect }      from 'react-router-dom';
import AssignmentList    from './AssignmentList';
import Assignment        from './Assignment';
import StudentAssignment from './StudentAssignment';
import AssignmentGrader  from './AssignmentGrader';

export const AssignmentConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/assignment/student/:calendar_event_id',
            component : StudentAssignment,
            permission: { component_name: 'assignment', permission_type: 'read' },
        },
        {
            path      : '/assignment/grader/:student_assignment_id',
            component : AssignmentGrader,
            permission: { component_name: 'assignment', permission_type: 'grade' },
        },
        {
            path      : '/assignment/:view_type/:assignment_id',
            component : Assignment,
            permission: { component_name: 'assignment', permission_type: 'view_type' },
        },
        {
            path      : '/assignment/list',
            component : AssignmentList,
            permission: { component_name: 'assignment', permission_type: 'list' },
        },
        {
            path      : '/assignment/:view_type/',
            component : Assignment,
            permission: { component_name: 'assignment', permission_type: 'view_type' },
        },
        {
            path      : '/assignment',
            component : () => <Redirect to="/assignment/list" />,
            permission: { component_name: 'assignment', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/assignment/AssignmentConfig.js